import { ca } from '@cian/analytics';
import { IAgentSchema, IOfferSchema, IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';
import { IRosreestrInfo } from 'shared/types/offerData';
import { getIsCommercialByOffer } from 'shared/utils/getIsCommercialByOffer';
import { getCustomUrl } from 'shared/utils/tracking/getCustomUrl';
import { getPage } from 'shared/utils/tracking/getPage';
import { getPartner } from 'shared/utils/tracking/getPartner';
import { getUser } from 'shared/utils/tracking/getUser';
import { getProducts } from 'shared/utils/tracking/get_products';

interface ITrackShowPhoneClick {
  trackingAction?: string;
  offer: IOfferSchema;
  agent: IAgentSchema | null;
  user: IUserSchema | null;
  kpId: number | null;
  bot?: boolean;
  isAgentNotAvailable?: boolean | null;
  siteBlockId?: number | null;
  rosreestrInfo?: IRosreestrInfo | null;
  /** ДинКТ вторички (SEL-998): связывает расхлоп с запросом подменного номера */
  clickId?: string;
}

export function trackShowPhoneClick({
  trackingAction,
  offer,
  agent,
  user,
  kpId,
  rosreestrInfo,
  bot,
  isAgentNotAvailable,
  siteBlockId,
  clickId,
}: ITrackShowPhoneClick) {
  const products = getProducts({ agent, offer, kpId, siteBlockId, rosreestrInfo });

  const isNeedToEnrichEvent = getIsCommercialByOffer(offer);
  const page = getPage(agent, offer, siteBlockId);

  ca('eventEbc', {
    action: trackingAction || `Open_card_floating_block${bot ? '_bot' : ''}${isAgentNotAvailable ? '_inactive' : ''}`,
    category: 'Phones',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
    ...(isNeedToEnrichEvent && { event: 'oldevent' }),
    page: {
      ...page,
      ...(isNeedToEnrichEvent && { offerType: 'offer' }),
      ...(clickId ? { extra: { ...page.extra, click_id: clickId } } : {}),
    },
    partner: getPartner(user, offer),
    products: [
      {
        ...products,
        variant: products.variant ? products.variant.split('/') : [],
      },
    ],
    user: getUser(user, 0),
  });
}
